"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    includeCta: true,
    invertCtaColors: false,
    onClickCta: function () { },
    includeCheckbox: false,
    selected: false,
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map